import downloadIcon from '@jetbrains/icons/download'
import {IconButton} from '@jetbrains/teamcity-ui/dist/components'
import {resolveRelative} from '@jetbrains/teamcity-ui/dist/utils'
import classNames from 'classnames'

import {showDownloadAllArtifactsLink} from '../../../../utils/featureToggles'

import styles from './ArtifactsDownloadAll.module.css'

import {stringifyId} from 'src/types'
import type {BuildId, BuildTypeId} from 'src/types'

type Props = {
  className?: string
  buildId?: BuildId
  buildType?: BuildTypeId | null | undefined
  showHidden?: boolean | null | undefined
  compact?: boolean
}

export default function ArtifactsDownloadAll({
  className,
  buildId,
  buildType,
  showHidden,
  compact,
}: Props) {
  if (!showDownloadAllArtifactsLink) {
    return null
  }

  return (
    <IconButton
      href={resolveRelative(
        `/repository/downloadAll/${stringifyId(buildType)}/${stringifyId(
          buildId,
        )}:id/artifacts.zip${showHidden === true ? '?showAll=true' : ''}`,
      )}
      className={classNames(styles.downloadLink, className)}
      download="artifacts.zip"
      icon={downloadIcon}
      title="Download all"
      withBorder={!compact}
      rel="noreferrer"
      onClick={(even: React.SyntheticEvent) => even.stopPropagation()}
    >
      {compact ? null : 'Download all'}
    </IconButton>
  )
}
